
(() => {
  const root = document.querySelector('[data-olza-root]');
  if (!root) return;
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const cartDrawer = $('#cartDrawer');
  const cartOverlay = $('#cartOverlay');
  const cartItems = $('#cartItems');
  const cartSubtotal = $('#cartSubtotal');
  const cartCountEls = $$('[data-cart-count]');
  const toast = $('#olzaToast');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const formatMoney = cents => {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(cents/100);
  };
  const showToast = message => { if(!toast)return; toast.textContent=message; toast.classList.add('is-visible'); setTimeout(()=>toast.classList.remove('is-visible'),2200); };
  const lock = on => document.body.classList.toggle('no-scroll', on);
  const openCart = () => { cartDrawer?.classList.add('is-open'); cartOverlay?.classList.add('is-open'); cartDrawer?.setAttribute('aria-hidden','false'); lock(true); };
  const closeCart = () => { cartDrawer?.classList.remove('is-open'); cartOverlay?.classList.remove('is-open'); cartDrawer?.setAttribute('aria-hidden','true'); lock(false); };
  async function getCart(){ const r=await fetch(window.Shopify.routes.root+'cart.js'); if(!r.ok)throw new Error('cart'); return r.json(); }
  async function renderCart(open=false){
    try{
      const cart=await getCart(); cartCountEls.forEach(e=>e.textContent=cart.item_count);
      if(cartSubtotal) cartSubtotal.textContent=formatMoney(cart.total_price);
      if(cartItems){
        if(!cart.items.length) cartItems.innerHTML='<div class="empty-state"><div>🫧</div><h3>Tu carrito está vacío</h3><p>Agrega tus productos Olza favoritos.</p><a class="btn btn-primary" href="#destacados">Seguir comprando</a></div>';
        else cartItems.innerHTML=cart.items.map(item=>`<article class="drawer-cart-item"><a class="drawer-cart-media" href="${item.url}"><img src="${item.image||''}" alt="${item.product_title}"></a><div class="drawer-cart-info"><a class="drawer-cart-title" href="${item.url}">${item.product_title}</a>${item.variant_title&&item.variant_title!=='Default Title'?`<small>${item.variant_title}</small>`:''}<div class="drawer-cart-actions"><div class="drawer-qty"><button data-line="${item.key}" data-qty="${Math.max(0,item.quantity-1)}" aria-label="Restar">−</button><span>${item.quantity}</span><button data-line="${item.key}" data-qty="${item.quantity+1}" aria-label="Sumar">+</button></div><button class="drawer-remove" data-line="${item.key}" data-qty="0">Eliminar</button></div></div><strong class="drawer-cart-price">${formatMoney(item.final_line_price)}</strong></article>`).join('');
      }
      if(open) openCart();
    }catch(e){ showToast('No pudimos actualizar el carrito.'); }
  }
  async function updateCart(key, quantity){ await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})}); await renderCart(); }
  const normalizeText = value => (value || '')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  let allProductsPromise;
  async function fetchJson(url){
    const response=await fetch(url,{headers:{'Accept':'application/json'}});
    if(!response.ok) throw new Error('request');
    return response.json();
  }
  async function loadAllProducts(){
    if(!allProductsPromise){
      allProductsPromise=(async()=>{
        const urls=[
          window.Shopify.routes.root+'products.json?limit=250',
          window.Shopify.routes.root+'collections/all/products.json?limit=250'
        ];
        for(const url of urls){
          try{
            const data=await fetchJson(url);
            const products=data.products||[];
            if(products.length) return products;
          }catch(error){}
        }
        return [];
      })();
    }
    return allProductsPromise;
  }
  function productFamily(value){
    const text=normalizeText(value);
    if(text.includes('essentials') || text.includes('essential')) return 'essentials';
    if(text.includes('crown')) return 'crown';
    return '';
  }
  function isBoxProduct(value){
    const compact=normalizeText(value).replace(/\s+/g,'');
    return compact.includes('caja') || compact.includes('box') || compact.includes('pack') ||
      /12(?:x|\*)1l/.test(compact) || /12botellas/.test(compact);
  }
  function sizeTokens(value){
    const compact=normalizeText(value).replace(/\s+/g,'');
    if(/12(?:x|\*)1l/.test(compact) || /12botellas/.test(compact) || isBoxProduct(value)) return '12';
    if(/10(?:l|litro|litros)/.test(compact)) return '10';
    if(/5(?:l|litro|litros)/.test(compact)) return '5';
    if(/1(?:l|litro|litros)/.test(compact)) return '1';
    return '';
  }
  function chooseProductAndVariant(products, query, variantLabel){
    const family=productFamily(query);
    const wantsBox=isBoxProduct(query) || sizeTokens(variantLabel)==='12';
    const wantedSize=sizeTokens(variantLabel) || sizeTokens(query);
    const scored=[];
    products.forEach(product=>{
      const title=normalizeText(product.title);
      if(family && productFamily(title)!==family) return;
      const productIsBox=isBoxProduct(title);
      if(productIsBox!==wantsBox) return;
      const variants=product.variants||[];
      variants.forEach(variant=>{
        const variantTitle=normalizeText(variant.title);
        const variantSize=sizeTokens(variantTitle) || sizeTokens(title);
        if(wantedSize && variantSize!==wantedSize) return;
        let score=0;
        if(productFamily(title)===family) score+=100;
        if(productIsBox===wantsBox) score+=100;
        if(wantedSize && variantSize===wantedSize) score+=200;
        if(title.includes(normalizeText(query))) score+=40;
        if(variant.available!==false) score+=20;
        scored.push({product,variant,score});
      });
    });
    scored.sort((a,b)=>b.score-a.score);
    return scored[0]||null;
  }
  async function predictiveProducts(searchTerm){
    const params=new URLSearchParams({
      q:searchTerm,
      'resources[type]':'product',
      'resources[limit]':'10',
      'resources[options][unavailable_products]':'show'
    });
    try{
      const data=await fetchJson(window.Shopify.routes.root+'search/suggest.json?'+params.toString());
      return data?.resources?.results?.products||[];
    }catch(error){ return []; }
  }
  async function hydrateSearchProducts(searchResults){
    const hydrated=[];
    const seen=new Set();
    for(const item of searchResults){
      const rawUrl=item.url || (item.handle ? window.Shopify.routes.root+'products/'+item.handle : '');
      if(!rawUrl) continue;
      const productUrl=rawUrl.split('?')[0];
      if(seen.has(productUrl)) continue;
      seen.add(productUrl);
      try{
        const detail=await fetchJson(productUrl+'.js');
        detail.url=productUrl;
        hydrated.push(detail);
      }catch(error){}
    }
    return hydrated;
  }
  async function searchProductAndVariant(query, variantLabel){
    const family=productFamily(query);
    const terms=[query, family, family==='essentials'?'essential':''].filter(Boolean);
    const results=[];
    for(const term of [...new Set(terms)]) results.push(...await predictiveProducts(term));
    const details=await hydrateSearchProducts(results);
    return chooseProductAndVariant(details,query,variantLabel);
  }
  function variantMatchesLabel(variant, label){
    const wanted=sizeTokens(label);
    if(!wanted) return true;
    const titleSize=sizeTokens(variant.title||'');
    return titleSize===wanted;
  }
  async function resolveProductByHandle(handle, variantLabel){
    if(!handle) return null;
    try{
      const product=await fetchJson(window.Shopify.routes.root+'products/'+encodeURIComponent(handle)+'.js');
      product.url=window.Shopify.routes.root+'products/'+handle;
      let variant=(product.variants||[]).find(v=>variantMatchesLabel(v,variantLabel));
      if(!variant) variant=(product.variants||[]).find(v=>v.available!==false) || product.variants?.[0];
      return variant ? {product,variant} : null;
    }catch(error){ return null; }
  }
  async function resolveProduct(query, variantLabel, handle){
    let match=await resolveProductByHandle(handle,variantLabel);
    if(match?.variant) return match;
    const products=await loadAllProducts();
    match=chooseProductAndVariant(products,query||handle,variantLabel);
    if(match?.variant) return match;
    match=await searchProductAndVariant(query||handle,variantLabel);
    return match?.variant ? match : null;
  }
  async function resolveDynamicProductForm(form){
    const query=form.dataset.productQuery||'', handle=form.dataset.productHandle||'', variantLabel=form.dataset.variantLabel||'';
    if(!query && !handle) return;
    const button=$('button[type=submit]',form), idInput=$('input[name=id]',form), price=$('.price',form);
    button.disabled=true;
    button.textContent='Cargando…';
    try{
      const match=await resolveProduct(query,variantLabel,handle);
      if(!match?.variant) throw new Error('variant');
      idInput.value=match.variant.id;
      const rawPrice=Number(match.variant.price);
      if(price) price.textContent=formatMoney(rawPrice < 10000 ? rawPrice*100 : rawPrice);
      button.disabled=match.variant.available===false;
      button.textContent=match.variant.available===false?'Agotado':'Agregar al carrito +';
      form.dataset.fallback='false';
      form.dataset.needsResolve='false';
      const card=form.closest('.product-card');
      const productUrl=match.product.url||window.Shopify.routes.root+'products/'+match.product.handle;
      card?.querySelectorAll('a').forEach(link=>link.href=productUrl+'?variant='+match.variant.id);
    }catch(error){
      // Never redirect the add-to-cart button to a guessed product URL. A guessed
      // handle can return Shopify's 404 page. Leave the card in place and retry
      // product resolution when the customer submits the form.
      button.disabled=false;
      button.textContent='Agregar al carrito +';
      form.dataset.fallback='true';
      form.dataset.needsResolve='true';
    }
  }
  $$('.dynamic-product-form').forEach(resolveDynamicProductForm);
  $$('[data-quantity-control]').forEach(control=>{const input=$('input[name=quantity]',control); $('[data-qty-minus]',control)?.addEventListener('click',()=>{input.value=String(Math.max(1,(Number(input.value)||1)-1));}); $('[data-qty-plus]',control)?.addEventListener('click',()=>{input.value=String(Math.max(1,(Number(input.value)||1)+1));}); input?.addEventListener('change',()=>{input.value=String(Math.max(1,Number(input.value)||1));});});
  $$('.olza-product-form').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault(); const b=$('button[type=submit]',form); const formData=new FormData(form); const id=Number(formData.get('id')); const quantity=Math.max(1,Number(formData.get('quantity'))||1); if((!id || form.dataset.needsResolve==='true') && (form.dataset.productQuery||form.dataset.productHandle)){await resolveDynamicProductForm(form); formData.set('id',$('input[name=id]',form)?.value||'');} const resolvedId=Number(formData.get('id')); if(!resolvedId){showToast('No pudimos identificar este producto. Revisa la asignación del producto en el editor del tema.');return;} b.disabled=true; try{const r=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:resolvedId,quantity}]})}); if(!r.ok){const error=await r.json().catch(()=>({})); throw new Error(error.description||error.message||'cart');} await renderCart(true); showToast(quantity===1?'Producto agregado al carrito.':quantity+' productos agregados al carrito.');}catch(err){showToast(err.message&&err.message!=='cart'?err.message:'No pudimos agregar el producto.');}finally{b.disabled=false;}}));
  cartItems?.addEventListener('click',e=>{const b=e.target.closest('[data-line]'); if(b)updateCart(b.dataset.line,Number(b.dataset.qty));});
  $$('[data-open-cart]').forEach(b=>b.addEventListener('click',()=>renderCart(true)));
  $$('[data-close-cart]').forEach(b=>b.addEventListener('click',closeCart)); cartOverlay?.addEventListener('click',closeCart);
  $('#checkoutButton')?.addEventListener('click',()=>location.href=window.Shopify.routes.root+'checkout');
  const menu=$('#mobileMenu'), menuButton=$('#menuButton'); menuButton?.addEventListener('click',()=>{const o=menu.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(o));}); $$('#mobileMenu a').forEach(a=>a.addEventListener('click',()=>menu.classList.remove('is-open')));
  $$('.faq-question').forEach(q=>q.addEventListener('click',()=>{const item=q.closest('.faq-item'); const open=item.classList.toggle('is-open'); q.setAttribute('aria-expanded',String(open));}));
  const articleModal = $('#articleModal');
  const articleTitle = $('#articleModalTitle');
  const articleBody = $('#articleModalBody');
  const articleIcon = $('#articleModalIcon');
  const articles = {
    rutina: {
      icon: '🗓️',
      title: 'Cómo crear una rutina de limpieza semanal',
      body: `<p>Una casa limpia no necesita jornadas agotadoras. La clave está en repartir las tareas durante la semana y mantener una rutina breve, realista y constante.</p><h3>1. Empieza por lo esencial</h3><p>Define las zonas que más usas: cocina, baño, recámaras y sala. Prioriza superficies, pisos, ropa y basura antes de agregar tareas más detalladas.</p><h3>2. Asigna un enfoque a cada día</h3><ul><li><strong>Lunes:</strong> ropa y recámaras.</li><li><strong>Martes:</strong> baño.</li><li><strong>Miércoles:</strong> cocina.</li><li><strong>Jueves:</strong> sala y áreas comunes.</li><li><strong>Viernes:</strong> pisos y detalles pendientes.</li></ul><h3>3. Trabaja en bloques cortos</h3><p>Dedica entre 15 y 25 minutos. Pon música, prepara tus productos y termina una sola zona antes de pasar a otra.</p><h3>4. Cierra con un hábito pequeño</h3><p>Antes de dormir, guarda objetos fuera de lugar, limpia una superficie y deja lista la ropa del día siguiente. Esos minutos evitan que el desorden se acumule.</p>`
    },
    colores: {
      icon: '👕',
      title: 'Cómo cuidar los colores de tu ropa',
      body: `<p>Con algunos cuidados sencillos puedes conservar la intensidad de tus prendas y evitar que se vean desgastadas antes de tiempo.</p><h3>Separa antes de lavar</h3><p>Agrupa tonos oscuros, claros y blancos. Las prendas nuevas o de colores intensos pueden soltar pigmento durante los primeros lavados.</p><h3>Lava con agua fría</h3><p>El agua fría ayuda a proteger las fibras y reduce la pérdida de color. Usa el ciclo apropiado y evita sobrecargar la lavadora.</p><h3>Voltea las prendas</h3><p>Lava pantalones, playeras y prendas estampadas al revés. Esto disminuye la fricción visible en la cara exterior.</p><h3>Usa la cantidad correcta de detergente</h3><p>Más producto no significa más limpieza. Una dosificación adecuada evita residuos y ayuda a que la ropa se enjuague correctamente.</p><h3>Evita el sol directo por demasiado tiempo</h3><p>Secar al aire es excelente, pero la exposición prolongada al sol puede desteñir algunos colores. Busca un espacio ventilado con sombra parcial.</p>`
    },
    orden: {
      icon: '✨',
      title: '5 hábitos para una casa más ordenada',
      body: `<p>El orden se construye con acciones pequeñas y repetidas. Estos cinco hábitos ayudan a mantener tus espacios agradables sin dedicar horas enteras.</p><h3>1. Devuelve cada objeto a su lugar</h3><p>Cuando termines de usar algo, guárdalo de inmediato. La regla de un minuto evita montones y pendientes.</p><h3>2. Deja las superficies despejadas</h3><p>Mantén mesas, barras y burós con pocos objetos. Una superficie libre hace que todo el espacio se vea más limpio.</p><h3>3. Haz una ronda nocturna</h3><p>Dedica diez minutos a recoger la sala, acomodar cojines, llevar vasos a la cocina y preparar lo necesario para el día siguiente.</p><h3>4. Aplica la regla entra uno, sale uno</h3><p>Cuando compres una prenda u objeto nuevo, considera donar o retirar uno que ya no uses.</p><h3>5. Limpia mientras avanzas</h3><p>En la cocina, lava utensilios mientras cocinas. En el baño, seca salpicaduras al terminar. Resolver lo pequeño en el momento evita tareas grandes después.</p>`
    }
  };
  const openArticle = key => {
    const article = articles[key]; if(!article || !articleModal) return;
    articleTitle.textContent = article.title; articleBody.innerHTML = article.body; articleIcon.textContent = article.icon;
    articleModal.classList.add('is-open'); articleModal.setAttribute('aria-hidden','false'); lock(true);
  };
  const closeArticle = () => { articleModal?.classList.remove('is-open'); articleModal?.setAttribute('aria-hidden','true'); lock(false); };
  $$('.article-open').forEach(button=>button.addEventListener('click',()=>openArticle(button.dataset.article)));
  $$('[data-close-article]').forEach(button=>button.addEventListener('click',closeArticle));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();closeArticle();}}); renderCart();
})();
